var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7145 23.1424H48.8574C47.4371 23.1424 46.2859 24.2937 46.2859 25.7139C46.2859 27.1341 47.4371 28.2854 48.8574 28.2854H61.7145C63.1348 28.2854 64.286 29.4367 64.286 30.8569V64.2858C64.286 65.706 63.1348 66.8573 61.7145 66.8573H10.2856C8.86541 66.8573 7.71414 65.706 7.71414 64.2858V30.8568C7.71414 29.4365 8.86541 28.2853 10.2856 28.2853H23.1428C24.563 28.2853 25.7143 27.134 25.7143 25.7138C25.7143 24.2935 24.563 23.1423 23.1428 23.1423H10.2856C6.02512 23.1423 2.57129 26.5961 2.57129 30.8566V64.2855C2.57129 68.546 6.02512 71.9998 10.2856 71.9998H61.7145C65.9751 71.9998 69.4289 68.546 69.4289 64.2855V30.8568C69.4289 26.5963 65.9751 23.1424 61.7145 23.1424Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6758 13.6101L37.8186 0.752878C36.8146 -0.251041 35.1867 -0.251041 34.1827 0.752878L21.3253 13.6101C20.3387 14.6316 20.3671 16.2595 21.3886 17.2461C22.3851 18.2085 23.9649 18.2085 24.9615 17.2461L33.4293 8.77821V51.4284C33.4293 52.8486 34.5806 53.9999 36.0008 53.9999C37.421 53.9999 38.5723 52.8486 38.5723 51.4284V8.77836L47.0402 17.2462C48.0617 18.2328 49.6896 18.2045 50.6761 17.1829C51.6383 16.1864 51.6383 14.6066 50.6758 13.6101Z",
    fill: "#D6D6D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.0d2d1b0f.svg";
export { ForwardRef as ReactComponent };